import { InjectionToken } from '@angular/core';
import { AnalyticsServiceInterface } from '../services';

export const APP_ANALYTICS = new InjectionToken<AnalyticsServiceInterface>(
  'APP_ANALYTICS'
);
